import React, { Component } from 'react';
import {
  compose,
  branch,
  renderComponent,
} from 'recompose';
import EmptyState from '../EmptyState';
import OrderItems from './OrderItems';
import { OrderCard } from './OrderCard';
import AccountInfo from '../AccountInfo';
import { withOrdersData } from '../../Common/Providers/OrderListApi';
import { HTMLTrans } from '../../Common/Translations';
import Pagination from '../../Common/Pagination';

const isOrdersEmpty = ({ orders = [] }) => (orders.length < 1);
const enhanceOrderComp = compose(
  withOrdersData,
  branch(
    isOrdersEmpty,
    renderComponent(AccountInfo),
  ),
);

class Order extends Component {
  render() {
    const {
      orders = [],
      lastPageNumber,
      currentPageNumber,
      getDataByPage,
      tRoute
    } = this.props;

    const data = {
      heading: <HTMLTrans id="account.order_heading">My Orders</HTMLTrans>,
      body: {
        header: <p><HTMLTrans id="account.order_body_header">You haven't made any orders yet. Let's create new project now.</HTMLTrans></p>,
        description: <HTMLTrans id="account.order_body_description">Start creating new project with many of our products range.</HTMLTrans>,
      },
      ctaButtons: [
        { type: 'primary', refresh: true, label: <HTMLTrans id="account.order_button_label">Create A Project Now</HTMLTrans>, url: tRoute('/product') },
      ],
    };

    if (orders.length < 1) {
      return <EmptyState data={data}/>
    }

    return (
      <div className='dashboard-card p-3 p-lg-5'>
        <h3>{data.heading}</h3>
        <hr />
        <div className=' my-5'>
          {orders.map((order) => (
              <OrderCard key={order.orderNumber} {...order}>
                <OrderItems currentOrderPageNumber={currentPageNumber} {...order}/>
              </OrderCard>
            ))}
        </div>
      <Pagination lastPageNumber={lastPageNumber}
          currentPageNumber={currentPageNumber}
          onClick={getDataByPage} />
      </div>
    );
  }
}

export default enhanceOrderComp(Order);
export const undecorated = Order;



// WEBPACK FOOTER //
// ./src/Account/Order/Order.js